import React, { useEffect, useState, useContext, useRef, useCallback } from 'react';
import { getAllTaskIDsForHeadID, getTaskInfo, getValidHeadSN, getValidBaseSN,getValidComponentHeader, getLoft, getComponentType, getValidShaftSN } from '../isdlData/taskmanData';
import { getGolfersFromTaskId, CreateTaskSession, LoadSession } from '../isdlData/sessionData';
import './Components.css';
import Select from 'react-select';
import Collapsible from 'react-collapsible';
import BuildableGolferList from './BuildableGolferList';
import UserList from './UserList';
import { GetUser } from '../isdlData/matrixUserData';
import TaskIdInput from './TaskIdInput';
import { getUser } from '../isdlData/matrixUserData';
import HeadIdTaskIdInput from './HeadIdTaskIdInput';
import VenueList from './VenueList';
import { AppContext, TaskIdDataContext } from '../contexts/AppContext';
import { rescan_barcode } from '../mobile/mobileHandler';
import { Modal } from '@mui/material';
import { Cross2Icon, ArrowUp, ArrowDown, AddIcon, HandleIcon } from '../icons/Icons';
import { intToUppercaseLetter, generateGUID, isValidRobotTestDataField } from '../utils/Utilities';
import { getFacemapData } from '../isdlData/facemapData';
import FlipMove from 'react-flip-move';
import { useAppStateService } from '../contexts/AppState';
import { DndContext, DragOverlay, closestCenter } from '@dnd-kit/core';
import { SortableContext, arrayMove, rectSwappingStrategy, useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { GetBallTests } from '../isdlData/constantsData';

const INTMIN = -2147483648;
const COR_DEFAULT_VENUE = 'COR lab';
const COR_DEFAULT_GOLFER_ID_EMAIL1 = 'CORcannon1@callawaygolf.com';//'COR Cannon1';
const COR_DEFAULT_GOLFER_ID_EMAIL2 = 'CORcannon2@callawaygolf.com';//'COR Cannon2';


function TaskmanSetup({taskId, headPrototypeId, HandleTaskSetup, taskmanIndex, registerCloseHandler, parentClose}){

    const [manualEntry, setManualEntry] = useState(false);
    const [useHDId, setUseHDId] = useState(false);
    const [loadingTaskIdList, setLoadingTaskIdList] = useState(true);
    const [assocTaskId, setAssocTaskId] = useState([]);
    const [selectedTaskOption, setSelectedTaskOption] = useState(null);
    const [, setLoadingTaskIdData] = useState(true);
    const [taskIdDataLoadingText, setTaskIdDataLoadingText] = useState("Please select a Task ID");
    const [taskComponentData, setTaskComponentData] = useState([]);
    const [loadedDC, setLoadedDC] = useState("");
    const [, setCanEditUsers] = useState(false);

    const modalRef = useRef(null);
    const scrollRef = useRef(null);

    const appState = useAppStateService();
    const { isInApp } = useContext(AppContext);
    const { taskIdData, setTaskIdData } = useContext(TaskIdDataContext);

    const [manualEntryMethod, setManualEntryMethod] = useState("");

    const [preInputtedHeadTaskId, setPreInputtedHeadTaskId] = useState("");

    const [selectedHeadId, setSelectedHeadId] = useState("");
    const [selectedTaskId, setSelectedTaskId] = useState("");
    const [validTaskId, setValidTaskId] = useState(false);
    const taskIdRef = useRef(null);
    const [selectedGolfers, setSelectedGolfers] = useState([]);
    const [selectedTests, setSelectedTests] = useState([]);
    const [ballTestOptions, setBallTestOptions] = useState([]);
    const [selectedTestOption, setSelectedTestOption] = useState(null);
    const [newTestModalOpen, setNewTestModalOpen] = useState(false);
    const [newTestName, setNewTestName] = useState("");
    const [loadedGolfers, setLoadedGolfers] = useState([]);
    const [activeTestId, setActiveTestId] = useState(null);
    const golfersRef = useRef(null);
    const testsRef = useRef(null);
    const [selectedDC, setSelectedDC] = useState("");
    const dcRef = useRef(null);
    const [selectedVenue, setSelectedVenue] = useState("");
    const [loadedVenue, setLoadedVenue] = useState("");
    const venueRef = useRef(null);
    const [valid, setValidation] = useState(false);
    const [initialTestPointer, setInitialTestPointer] = useState(null);
    const [testPointerCoordinates, setTestPointerCoordinates] = useState({ x: 0, y: 0 });

    //test types:
    //CLUB: normal club test
    //FACEMAP: face map test
    //BALL: ball test [not implimented]
    const [testType, setTestType] = useState("CLUB");
    const [testData, setTestData] = useState(null);
    const [robotTestData, setRobotTestData] = useState(null);

    const [loadingModal, setLoadingModalState] = useState(false);
    const [loadingModalText, setLoadingModalText] = useState("");

    const [errorModal, setErrorModalState] = useState(false);
    const [errorModalText, setErrorModalText] = useState("");

    const [closeModal, setCloseModalState] = useState(false);

    const [conflictTaskModal, setConflictTaskModalState] = useState(false);
    const [conflictTaskSessionId, setConflictTaskSessionId] = useState('');

    const headIdTaskIdInputRef = useRef();
    const taskIdInputRef = useRef();

    useEffect(() => {
        if(appState.InApp){
            window.addEventListener('barcodeScanValue',handleNewScan);
        }

      return () => {
        if(appState.InApp){
            window.removeEventListener('barcodeScanValue',handleNewScan);
        }
      }
      }, [isInApp]);

    useEffect(() => {
        let mounted = true;

        const loadBallTests = async () => {
            const tests = await GetBallTests();

            if (mounted) {
                setBallTestOptions(Array.isArray(tests) ? tests : []);
            }
        };

        loadBallTests();

        return () => {
            mounted = false;
        };
    }, []);

    useEffect(() => {
        const selectedTestsByGroup = taskIdData?.selected_tests;

        if (
            !selectedTaskId ||
            taskIdData?.full_task !== selectedTaskId ||
            !selectedTestsByGroup ||
            typeof selectedTestsByGroup !== 'object' ||
            ballTestOptions.length === 0
        ) {
            setSelectedTests([]);
            return;
        }

        const importedTestNames = Object.values(selectedTestsByGroup)
            .filter(Array.isArray)
            .flat();
        const importedTests = importedTestNames.reduce((tests, testName) => {
            const option = ballTestOptions.find(
                (candidate) => candidate.value === testName || candidate.label === testName
            );

            if (option && !tests.some((test) => test.value === option.value)) {
                tests.push(option);
            }

            return tests;
        }, []);

        setSelectedTests(importedTests);
    }, [selectedTaskId, taskIdData?.full_task, taskIdData?.selected_tests, ballTestOptions]);

    const selectedHeadIdRef = useRef(selectedHeadId);
    const selectedTaskIdRef = useRef(selectedTaskId);

    // Update refs whenever the states change:
    useEffect(() => {
        selectedHeadIdRef.current = selectedHeadId;
    }, [selectedHeadId]);

    useEffect(() => {
        selectedTaskIdRef.current = selectedTaskId;
    }, [selectedTaskId]);

    // Create a stable callback that reads from the refs:
const closeHandler = useCallback(() => {
    if (
      (selectedHeadIdRef.current !== "" && selectedTaskIdRef.current === "") ||
      (selectedTaskIdRef.current !== "" && selectedHeadIdRef.current === "")
    ) {
      setCloseModalState(true);
    } else {
      handleConfirmClose();
    }
  }, []); // empty dependency array because it reads from refs

      // Register the handler once:
useEffect(() => {
    if (registerCloseHandler) {
      registerCloseHandler(closeHandler);
    }
  }, [registerCloseHandler, closeHandler]);

    useEffect(() => {
        if((taskId === null || taskId === undefined || taskId === "") &&
        (headPrototypeId === null || headPrototypeId === undefined || headPrototypeId === "")){
            setTaskIdData(null);
            // setManualEntry(true);
        }
        else if((taskId === null || taskId === undefined || taskId === "") && headPrototypeId !== ""){
            // setManualEntry(false);
            setUseHDId(true);
            setSelectedHeadId(headPrototypeId);
        }else{
            // setManualEntry(false);
            setUseHDId(false);
            setSelectedTaskId(taskId);
            setSelectedTaskOption({value: taskId, label: taskId});
        }

        const loadDCData = async () =>{
            const dcemail = sessionStorage.getItem('dataCollectorEmail');
    
            if(dcemail && isEmailCleanable(dcemail)){
                const cleanedEmail = cleanEmail(dcemail);
    
                const userData = await GetUser(cleanedEmail.toLowerCase());
                setLoadedDC(cleanedEmail.toLowerCase());
                if(userData.Role === "Admin" || userData.Role === "DataCollector"){
                    setCanEditUsers(true);
                }else{
                    setCanEditUsers(false);
                }
            }else{
                setCanEditUsers(false);
            }
        }
        loadDCData();
    },[taskmanIndex]);

    useEffect(() => {
        const loadTaskIdList = async () => {
            setLoadingTaskIdList(true);
            setLoadingModalState(true);
            setLoadingModalText("Loading list of Task IDs")
            const tasks = await getAllTaskIDsForHeadID(selectedHeadId);

            const initTaskIdList = Array.isArray(tasks) ? tasks : [tasks];
            
            // setTaskIdDataLoadingText("Please select a Task ID");
            // const initTaskIdList = testTaskdIdList;
            if(initTaskIdList !== null && initTaskIdList !== undefined && initTaskIdList.length > 0){
                const list = initTaskIdList.map(id => ({value: id, label: id}));
                setAssocTaskId(list);

                if(list.length === 1){
                    setSelectedTaskOption({value: initTaskIdList[0], label: initTaskIdList[0]});
                    setSelectedTaskId(initTaskIdList[0]);
                    setLoadingTaskIdList(false);
                }
            }else if(initTaskIdList.length === 0){
                setSelectedTaskOption(null);
                setSelectedTaskId("");
                setLoadingModalState(false);
                setErrorModalText("No Task found for Head ID");
                setErrorModalState(true);
                setTaskIdDataLoadingText("No Task found for Head ID");
            }
            setLoadingTaskIdList(false);
            setLoadingModalState(false);

        };

        if(selectedHeadId !== ""){
            loadTaskIdList();
        }else{
            if(taskId === ""){
                setAssocTaskId([]);
                setSelectedTaskOption(null);
                setSelectedTaskId("");
            }
        }
    },[selectedHeadId])

    useEffect(() => {
        const loadTaskIdData = async () => {
            setLoadingTaskIdData(true);
            // setTaskIdDataLoadingText("Loading Task ID data for " + selectedTaskId);
            setLoadingModalText("Loading Task ID data for " + selectedTaskId)
            setLoadingModalState(true);

            const sessionList = await getGolfersFromTaskId(selectedTaskId);
            const sessions = Array.isArray(sessionList) ? sessionList : [sessionList];

            if(sessions !== null && sessions !== undefined && sessions.length > 0){
                setValidTaskId(false);
                setTaskIdData(null);
                setTaskComponentData([]);
                setLoadingModalState(false);
                // setErrorModalText("Task already has a session.");
                // setErrorModalState(true);
                setConflictTaskModalState(true);
                setConflictTaskSessionId(sessions[0]);
                // setTaskIdDataLoadingText("Task already has a session.");
                return;
            }else{
                setValidTaskId(true);
            }

            let initTaskIdData = null;
            
            try{
                initTaskIdData = await getTaskInfo(selectedTaskId);
                var stophere = 1;
                //DEBUG, REMOVE LATER
                //initTaskIdData["robot_face_location"] = "C/T/H";
            }catch(e){
                if(e.message === 'HTTP error 404'){
                    setErrorModalText("Task not found.");
                    setErrorModalState(true);
                }else if(e.message === 'HTTP error 500'){
                    setErrorModalText("Task fetch failed.");
                    setErrorModalState(true);
                }
            }
            // const initTaskIdData = testTaskData;
            
              setTaskIdData(initTaskIdData);
              if(initTaskIdData !== null){
                let components = normalizeTaskComponents(initTaskIdData.components);
                setTaskComponentData(components);
                handleTaskType(initTaskIdData);
              }

            setLoadingTaskIdList(false);
            setLoadingTaskIdData(false);
            setLoadingModalState(false);
        }

        if(selectedTaskId !== "" && selectedTaskId !== null && selectedTaskId !== undefined){
            loadTaskIdData();
        }

    },[selectedTaskId]);

    useEffect(() => {
        const applyCorDefaults = async () => {
            const usesCorCannon =
                taskIdData?.cor_use_center === true ||
                taskIdData?.cor_use_hot_spot === true;

            if (!usesCorCannon) {
                return;
            }

            setLoadedVenue(COR_DEFAULT_VENUE);

            try {
                const golfer1 = await GetUser(COR_DEFAULT_GOLFER_ID_EMAIL1);
                const golfer2 = await GetUser(COR_DEFAULT_GOLFER_ID_EMAIL2);
                const golfers = golfer1 ? [golfer1,golfer2] : [];
                setLoadedGolfers(golfers);
                setSelectedGolfers(golfers);
            } catch (error) {
                console.warn(`Unable to load default COR golfers.`, error);
                setLoadedGolfers([]);
                setSelectedGolfers([]);
            }
        };

        applyCorDefaults();
    }, [selectedTaskId, taskIdData?.cor_use_center, taskIdData?.cor_use_hot_spot]);

    //validation
    useEffect(() => {
        let isValid = true;

        if(selectedTaskId === undefined || selectedTaskId === null || selectedTaskId === ""){
            isValid = false;
            invalidatedField(taskIdRef,false);
        }else{
            invalidatedField(taskIdRef,true);
            invalidatedField(taskIdInputRef,true);
        }

        if(!validTaskId){
            isValid = false;
            invalidatedField(taskIdRef,false);
        }else{
            invalidatedField(taskIdRef,true);
            invalidatedField(taskIdInputRef,true);
        }

        // if(taskIdData === null || taskIdData === undefined){
        //     isValid = false;
        //     invalidatedField(taskIdInputRef,false);
        //     invalidatedField(taskIdRef,false);
        // }

        if(taskIdData){
        }

        if(taskIdData?.task_type !== "Robot"){
            if(selectedGolfers === null || selectedGolfers === undefined || selectedGolfers.length === 0){
                isValid = false;
                invalidatedField(golfersRef,false);
            }else{
                invalidatedField(golfersRef,true);
            }
            invalidatedField(testsRef,true);
        }else{
            invalidatedField(golfersRef,true);
            if(selectedTests === null || selectedTests === undefined || selectedTests.length === 0){
                isValid = false;
                invalidatedField(testsRef,false);
            }else{
                invalidatedField(testsRef,true);
            }
        }

        if(selectedDC === null || selectedDC === undefined || selectedDC === ""){
            isValid = false;
            invalidatedField(dcRef,false);
        }else{
            invalidatedField(dcRef,true);
        }

        if(selectedVenue === null || selectedVenue === undefined || selectedVenue === ""){
            isValid = false;
            invalidatedField(venueRef,false);
        }else{
            invalidatedField(venueRef,true);
        }

        setValidation(isValid);
    },[selectedTaskId, validTaskId, selectedGolfers, selectedTests, selectedDC, selectedVenue, manualEntry, taskIdData?.task_type]);

    const handleTaskIdChange = (option) => {
        setTaskIdData(null);
        setTaskComponentData(null);
        setSelectedTaskOption(option);
        setSelectedTaskId(option.value);
    }

    const handleGolferListChange = (golfers) => {
        setSelectedGolfers(golfers);
    }

    const handleTestSelectChange = (option) => {
        setSelectedTestOption(null);

        if (!option) {
            return;
        }

        if (option.value === 'add-new-test') {
            setNewTestName("");
            setNewTestModalOpen(true);
            return;
        }

        setSelectedTests((prevTests) => {
            if (prevTests.some((test) => test.value === option.value)) {
                return prevTests;
            }

            return [...prevTests, option];
        });
    }

    const handleRemoveTest = (testValue) => {
        setSelectedTests((prevTests) => prevTests.filter((test) => test.value !== testValue));
    }

    const handleNewTestModalCancel = () => {
        setNewTestName("");
        setNewTestModalOpen(false);
    }

    const handleNewTestModalOk = () => {
        const trimmedName = newTestName.trim();

        if (trimmedName === "") {
            return;
        }

        const newTestOption = {
            value: `custom-${trimmedName.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`,
            label: trimmedName,
        };

        setSelectedTests((prevTests) => {
            if (prevTests.some((test) => test.label.toLowerCase() === trimmedName.toLowerCase())) {
                return prevTests;
            }

            return [...prevTests, newTestOption];
        });

        setNewTestName("");
        setNewTestModalOpen(false);
    }

    const handleTestDragStart = (event) => {
        const { active, activatorEvent } = event;
        setActiveTestId(active.id);

        if (activatorEvent?.clientX !== undefined) {
            setInitialTestPointer({ x: activatorEvent.clientX, y: activatorEvent.clientY });
            setTestPointerCoordinates({ x: activatorEvent.clientX, y: activatorEvent.clientY });
        } else if (activatorEvent?.touches?.[0]) {
            const { clientX, clientY } = activatorEvent.touches[0];
            setInitialTestPointer({ x: clientX, y: clientY });
            setTestPointerCoordinates({ x: clientX, y: clientY });
        }
    }

    const handleTestDragMove = (event) => {
        if (!initialTestPointer) {
            return;
        }

        setTestPointerCoordinates({
            x: initialTestPointer.x + event.delta.x,
            y: initialTestPointer.y + event.delta.y,
        });
    }

    const handleTestDragEnd = (event) => {
        const { active, over } = event;

        if (over && active.id !== over.id) {
            const oldIndex = selectedTests.findIndex((item) => item.value === active.id);
            const newIndex = selectedTests.findIndex((item) => item.value === over.id);
            setSelectedTests((prevTests) => arrayMove(prevTests, oldIndex, newIndex));
        }

        setActiveTestId(null);
        setInitialTestPointer(null);
        setTestPointerCoordinates({ x: 0, y: 0 });
    }

    const handleDCChange = (user) => {
        setSelectedDC(user);
    }

    const handleVenueChange = (venue) => {
        setSelectedVenue(venue);
    }

    const handleTaskmanComplete = async () =>{

        let taskData = {...taskIdData};
        taskData.components = taskComponentData;

        const sessionEntities = taskData?.task_type === "Robot" ? selectedTests : selectedGolfers;

        await CreateTaskSession(selectedTaskId, taskData, testData, sessionEntities, selectedDC, selectedVenue);

        setTaskIdData(null);
        HandleTaskSetup(null,"MAINWINDOW");
    }

    //Utils
    function isEmailCleanable(email) {
        // Regex to check if the email contains 'corp.' in the subdomain
        const corpDomainRegex = /^([^@]+)@corp\.(.+)$/;
        
        // Test if the email has 'corp.' in the domain part
        return corpDomainRegex.test(email);
    }

    function cleanEmail(email) {
        if (isEmailCleanable(email)) {
            // Remove 'corp.' from the domain
            return email.replace('corp.', '');
        }
        return email; // Return the original email if it's not cleanable
    }
    // function manualEntryMode(){
    //     if((taskId === null || taskId === undefined || taskId === "") &&
    //     (headPrototypeId === null || headPrototypeId === undefined || headPrototypeId === "")){
    //         setManualEntry(true);
    //         return true;
    //     }else{
    //         setManualEntry(false);
    //         return false;
    //     }
    // }
    const shouldManualEntry = 
    (taskId === null || taskId === undefined || taskId === "") &&
    (headPrototypeId === null || headPrototypeId === undefined || headPrototypeId === "");

    useEffect(() => {
        setManualEntry(shouldManualEntry);
      }, [shouldManualEntry]);

    function invalidatedField(field, isValid){
        if(!field.current){
            return;
        }

        if(!isValid){
            field.current.classList.add('new-setup-error-input');
        }else{
            field.current.classList.remove('new-setup-error-input');
        }
    }

    const handleTaskIdInput = (value) => {
        if(!value.committed){
            if(selectedTaskId !== "" || selectedHeadId !== ""){
                setSelectedTaskId("");
                setSelectedHeadId("");
                setTaskIdDataLoadingText("Please select a Task ID");
                setAssocTaskId([]);
                setManualEntryMethod("");
                setTaskIdData(null);
                setTaskComponentData(null);
                setSelectedTaskOption(null);
            }
            return;
        }

        if(value.valid && value.taskId !== "" && value.type === "TaskId"){
            setSelectedTaskId(value.taskId);
            setSelectedHeadId("");
            setTaskIdData(null);
            setTaskComponentData(null);
            setAssocTaskId([]);
            setSelectedTaskOption(null);
            setManualEntryMethod("TASKID");
        }else if(value.valid && value.taskId !== "" && value.type === "HeadId"){
            setSelectedHeadId(value.taskId);
            setSelectedTaskId("");
            setTaskIdData(null);
            setTaskComponentData(null);
            setAssocTaskId([]);
            setSelectedTaskOption(null);
            setManualEntryMethod("HEADID");
        }else if(value.valid && value.taskId === ""){
            if(selectedTaskId !== ""){
                setSelectedTaskId("");
            setSelectedHeadId("");
            setTaskIdDataLoadingText("Please select a Task ID");
                setAssocTaskId([]);
                setManualEntryMethod("");
                setTaskIdData(null);
                setTaskComponentData(null);
            }
        }else{
            if(selectedTaskId !== ""){
                setSelectedTaskId("");
            setSelectedHeadId("");
            setTaskIdDataLoadingText("Please select a Task ID");
                setAssocTaskId([]);
                setManualEntryMethod("");
                setTaskIdData(null);
                setTaskComponentData(null);
            }
        }
    }

    const handleTaskType = async (taskData) => {
        if(taskData.hasOwnProperty('robot_face_location') && typeof taskData.robot_face_location === "string" && taskData["robot_face_location"] !== '')
        {
            await setFacemapData(taskData["robot_face_location"], getGeneralizedClubCategory(getFirstComponentCategory(taskData)).toLowerCase());
            setTestType("FACEMAP");
            if(taskData.hasOwnProperty('RobotTestInfo')){
                let robotData = adjustRobotTestData(taskData["RobotTestInfo"]);
                // robotData["DynamicLoftTarget"] = INTMIN; //TEST IGNORE FIELD HERE
                // robotData["AttackTolerance"] = INTMIN; //TEST IGNORE FIELD HERE
                // robotData = adjustRobotTestData(robotData);
                setRobotTestData(robotData);
            }
        }else{
            setTestType("CLUB");
        }

        // switch(taskData["robot_face_location"].toLowerCase()){
        //     default:
        //     case "club":
        //         setTestType("CLUB");
        //         break;
        //     case "face map":
        //     case "c/t/h":
        //         center
        //         heel
        //         toe
        //         other
        //         await setFacemapData(taskData["robot_face_location"], getGeneralizedClubCategory(getFirstComponentCategory(taskData)).toLowerCase());
        //         setTestType("FACEMAP");
        //         break;
        // }
    }

    const setFacemapData = async (id, clubType) => {
        const refinedId = id.replace(/\//g, "");
        let facemapData = null;
        try{
            facemapData = await getFacemapData(refinedId);
        }catch(e){
            if(e.message === "HTTP error 404"){
                //huh
                setErrorModalText("Task has no valid face mapping available.");
                setErrorModalState(true);
            }
        }
        const locationData = getLocationsByClubType(facemapData, clubType);

        setTestData(locationData);
    }

    function getFirstComponentCategory(data) {
        if (
          data &&
          Array.isArray(data.components) &&
          data.components.length > 0 &&
          typeof data.components[0] === 'object' &&
          data.components[0] !== null
        ) {
          return data.components[0].category || null;
        }
        return null;
      }
    
    function getGeneralizedClubCategory(category){
        switch(category.toLowerCase()){
            case "irons":
            case "iron":
                return "iron";
            case "drivers":
            case "driver":
            case "woods":
            case "wood":
                return "driver";
            case "fairway wood":
            case "fairway woods":
                return "fairway wood";
            case "hybrids":
            case "hybrid":
                return "hybrid";
            case "wedge":
            case "wedges":
                return "wedge";
            default:
                return "";
        }
    }

    function getLocationsByClubType(data, clubType) {
        if (
          data &&
          Array.isArray(data.ClubTypes)
        ) {
          const match = data.ClubTypes.find(
            item => typeof item.ClubType === 'string' && item.ClubType.toLowerCase() === clubType.toLowerCase()
          );
          return match?.Locations || null;
        }
        return null;
    }

    const normalizeTaskComponents = (components = []) => (
        (Array.isArray(components) ? components : [])
            .filter((item) => item && typeof item === 'object')
            .map((item, index) => ({
                ...item,
                index,
                id: item.id || generateGUID()
            }))
    );
    
    function SwapComponents(i, j){
        setTaskComponentData(prev => {
        const copy = [...prev];
        [copy[i], copy[j]] = [copy[j], copy[i]];
        return copy.map((item, idx) => ({ ...item, index: idx }));
    });
    }

    function IsTopMostComponent(component){
        if(component.index === 0){
            return true;
        }else{
            return false;
        }
    }

    function IsBottomMostComponent(component){
        if(component.index === taskComponentData.length - 1){
            return true;
        }else{
            return false;
        }
    }

    const handleMoveComponentUp = (e, component) => {
        e.stopPropagation();
        e.preventDefault();

        SwapComponents(component.index, component.index-1);
    }

    const handleMoveComponentDown = (e, component) => {
        e.stopPropagation();
        e.preventDefault();
        
        SwapComponents(component.index, component.index+1);
    }

    const handleRescanClick = () => {
        if(appState.InApp){
            rescan_barcode();
            setSelectedTaskId("");

        }
    }

    const buildNewComponent = (existingComponents = []) => {
        const isBallTask = taskIdData?.task_type === "Robot" || getComponentType(existingComponents?.[0] || {}) === "Ball";
        const nextIndex = Array.isArray(existingComponents) ? existingComponents.length : 0;

        if (isBallTask) {
            return {
                base_comp_type: "Ball",
                group_num: "",
                index: nextIndex,
                id: generateGUID()
            };
        }

        const templateComponent = existingComponents?.[0] || {};
        return {
            base_comp_type: "Club",
            brand: templateComponent.brand ?? "",
            product: templateComponent.product ?? "",
            category: templateComponent.category ?? "",
            stated_loft: templateComponent.stated_loft ?? "",
            loft_id: templateComponent.loft_id ?? "",
            base_sn_label: "",
            head_sn_label: "",
            shaft_sn_label: "",
            loft_meas: null,
            lie_meas: null,
            mass: null,
            club_length: null,
            club_sw: "",
            club_freq: null,
            index: nextIndex,
            id: generateGUID()
        };
    };

    const handleAddComponent = () => {
        setTaskComponentData(prev => {
            const existingComponents = Array.isArray(prev) ? prev : [];
            return [
                ...existingComponents,
                buildNewComponent(existingComponents)
            ];
        });
    };

    const handleRemoveComponent = (componentId) => {
        setTaskComponentData(prev => {
            if (!Array.isArray(prev)) {
                return prev;
            }

            return prev
                .filter(component => component.id !== componentId)
                .map((component, index) => ({
                    ...component,
                    index
                }));
        });
    };

    const updateComponentField = (componentId, field, rawValue, valueType = "string") => {
        setTaskComponentData(prev => {
            if (!Array.isArray(prev)) {
                return prev;
            }

            return prev.map(component => {
                if (component.id !== componentId) {
                    return component;
                }

                let nextValue = rawValue;
                if (valueType === "number") {
                    nextValue = rawValue === "" ? null : Number(rawValue);
                    if (rawValue !== "" && Number.isNaN(nextValue)) {
                        nextValue = null;
                    }
                }

                return {
                    ...component,
                    [field]: nextValue
                };
            });
        });
    };

    const renderEditableComponentField = (component, label, field, valueType = "string", placeholder = "") => (
        <div className='taskman-collapsible-inner-item'>
            <div className='taskman-collapsible-inner-item-header'>{label}</div>
            <div className='taskman-collapsible-inner-item-content' style={{flexGrow: 1}}>
                <input
                    className='input'
                    type={valueType === "number" ? "number" : "text"}
                    step={valueType === "number" ? "any" : undefined}
                    value={component?.[field] ?? ""}
                    placeholder={placeholder}
                    onChange={(e) => updateComponentField(component.id, field, e.target.value, valueType)}
                    style={{height: '30px', width: '100%', boxSizing: 'border-box'}}
                />
            </div>
        </div>
    );

    const safeDisplayValue = (value, fallback = "N/A") => {
        if (typeof value === "string" || typeof value === "number") {
            return value;
        }

        return fallback;
    };

    const renderRemoveComponentButton = (component) => (
        <div style={{width:'100%', display:'flex', justifyContent:'flex-start', marginTop:'10px'}}>
            <button
                type='button'
                onClick={() => handleRemoveComponent(component.id)}
                className='button'
                // style={{
                //     height:'32px',
                //     padding:'0 12px',
                //     background:'transparent',
                //     border:'1px solid var(--foreground-secondary)',
                //     color:'var(--foreground-primary)',
                //     borderRadius:'8px',
                //     fontFamily:'inherit',
                //     fontSize:'14px'
                // }}
            >
                Remove Component
            </button>
        </div>
    );

    const handleNewScan = (data) => {
        const newCode = JSON.parse(data.detail).code;
        const regexTaskId = /^\d{4}-\d{5,6}-\d{2}$/; // Pattern: XXXX-XXXXX-XX
          const regexHeadId = /^HD-\d{7}$/;            // Pattern: HD-XXXXXXX
    
          if (regexTaskId.test(newCode)) {
            setPreInputtedHeadTaskId(newCode);
          } else if (regexHeadId.test(newCode)) {
            setPreInputtedHeadTaskId(newCode);
          }
    }

    const handleConfirmClose = () => {
        setCloseModalState(false);
        setTaskIdData(null);
        parentClose();
      };

    const handleLoadConflictSession = async () => {
        if(conflictTaskSessionId && conflictTaskSessionId.id)
        {
            setConflictTaskModalState(false)
            await LoadSession(conflictTaskSessionId.id);
            setTaskIdData(null);
            HandleTaskSetup(null, "MAINWINDOW");
        }else{
            setConflictTaskModalState(false)
            setErrorModalState(true);
            setErrorModalText("There was a problem opening that task session.");
        }
    }

    const handleLoadConflictSessionCancel = async () => {
        setConflictTaskModalState(false);
    }

    const getAdjustedRobotTestDataKey = (key) => {
        let returnVal = "";
        switch(key){
            case "NumberOfHits":
                returnVal = "Number Of Hits";
                break;
            case "AttackTarget":
                returnVal = "Attack Target";
                break;
            case "AttackTolerance":
                returnVal = "Attack Tolerance";
                break;
            case "PathTarget":
                returnVal = "Path Target";
                break;
            case "PathTolerance":
                returnVal = "Path Tolerance";
                break;
            case "FaceToPathTarget":
                returnVal = "Face To Path Target";
                break;
            case "FaceToPathTolerance":
                returnVal = "Face To Path Tolerance";
                break;
            case "DynamicLoftTarget":
                returnVal = "Dynamic Loft Target";
                break;
            case "DynamicLoftTolerance":
                returnVal = "Dynamic Loft Tolerance";
                break;
            case "DynamicLieTarget":
                returnVal = "Dynamic Lie Target";
                break;
            case "DynamicLieTolerance":
                returnVal = "Dynamic Lie Tolerance";
                break;
                case "TestType":
                returnVal = "Test Type";
                break;
            default:
                returnVal = key;
                break;
        }
        return returnVal;
    }

    const getAdjustedRobotTestDataValue = (key, value) => {
        let returnVal = "";
        switch(key){
            case "NumberOfHits":
                returnVal = value;
                break;
            case "AttackTarget":
            case "PathTarget":
            case "FaceToPathTarget":
            case "DynamicLoftTarget":
            case "DynamicLieTarget":
                returnVal = value + "°";
                break;
            case "AttackTolerance":
            case "PathTolerance":
            case "FaceToPathTolerance":
            case "DynamicLoftTolerance":
            case "DynamicLieTolerance":
                returnVal = "± " + value + "°";
                break;
            default:
                returnVal = value;
                break;
        }
        return returnVal;
    }

    const validRobotTestData = (key) => isValidRobotTestDataField(robotTestData, key);

    const adjustRobotTestData = (data) => {
        // let newData = {...data}; // this creates a new one
        let newData = data; // this alters the old data
        for(const [key, value] of Object.entries(newData)){
            switch(key){
            case "NumberOfHits":
                if(newData["NumberOfHits"] === INTMIN){
                    delete newData["NumberOfHits"];
                }
                break;
            case "AttackTarget":
            case "AttackTolerance":
                if(newData["AttackTarget"] === INTMIN || newData["AttackTolerance"] === INTMIN){
                    delete newData["AttackTarget"];
                    delete newData["AttackTolerance"];
                }
                break;
            case "PathTarget":
            case "PathTolerance":
                if(newData["PathTarget"] === INTMIN || newData["PathTolerance"] === INTMIN){
                    delete newData["PathTarget"];
                    delete newData["PathTolerance"];
                }
                break;
            case "FaceToPathTarget":
            case "FaceToPathTolerance":
                if(newData["FaceToPathTarget"] === INTMIN || newData["FaceToPathTolerance"] === INTMIN){
                    delete newData["FaceToPathTarget"];
                    delete newData["FaceToPathTolerance"];
                }
                break;
            case "DynamicLoftTarget":
            case "DynamicLoftTolerance":
                if(newData["DynamicLoftTarget"] === INTMIN || newData["DynamicLoftTolerance"] === INTMIN){
                    delete newData["DynamicLoftTarget"];
                    delete newData["DynamicLoftTolerance"];
                }
                break;
            case "DynamicLieTarget":
            case "DynamicLieTolerance":
                if(newData["DynamicLieTarget"] === INTMIN || newData["DynamicLieTolerance"] === INTMIN){
                    delete newData["DynamicLieTarget"];
                    delete newData["DynamicLieTolerance"];
                }
                break;
        }
    }
        return newData;
}

    return(
        <div ref={modalRef} className='taskman-background'>
            <div style={{width:'100%', height:'80px'}}/>
            <div style={{width:'calc(100% - 40px)', maxWidth:'1024px', height:'100%',overflow:'auto', flexGrow:'1'}} ref={scrollRef}>
                <div style={{display:'flex', flexDirection:'column', justifyContent:'start', alignItems:'center', width:'calc(100% - 40px)', height:'auto', margin:'20px'}}>
                    {appState.InApp && (
                        <div style={{display:'flex', flexDirection:'row', justifyContent:'center', alignItems:'center', width:'100%', marginBottom:'10px'}}>
                            <button className='button' onClick={() => handleRescanClick()}>Scan Barcode</button>
                        </div>
                    )}
                    {manualEntry && (
                        <div style={{display:'flex', flexDirection:'row', justifyContent:'start', alignItems:'center', width:'100%', marginBottom:'5px'}}>
                            <div style={{flexShrink:'0', marginRight:'10px', marginLeft:'10px'}}>Please enter a Head ID or Task ID</div>
                            <div ref={taskIdInputRef} style={{height:'90%', flexGrow:'1', marginRight:'10px'}}>
                                <HeadIdTaskIdInput ref={headIdTaskIdInputRef} result={handleTaskIdInput} PreInputtedText={preInputtedHeadTaskId}/>
                            </div>
                        </div>
                    )}
                    {(!manualEntry || (manualEntry && manualEntryMethod === "HEADID")) && (
                        <div style={{display:'flex', flexDirection:'row', justifyContent:'start', alignItems:'center', width:'100%'}}>
                            <div style={{height:'100%', alignContent:'center', marginRight:'20px', flex:'0', minWidth:'150px', marginLeft:'10px'}}>{useHDId ? "Choose Task ID" : "Selected Task ID"}</div>
                            <div ref={taskIdRef} style={{height:'100%', flex:'1', marginRight:'10px'}}>
                                <Select
                                    className='select'
                                    isLoading={loadingTaskIdList}
                                    options={assocTaskId}
                                    name='TaskIdSelect'
                                    onChange={handleTaskIdChange}
                                    styles={{zindex:"10"}}
                                    value={selectedTaskOption}
                                    menuPlacement="auto"
                                    isDisabled={manualEntry && manualEntryMethod === "HEADID" ? false : !useHDId}
                                    />
                            </div>
                            
                                
                        </div>
                    )}
                    <div className='taskman-header-inner'>Task Info</div>

                    { taskIdData !== null && taskIdData !== undefined && taskIdData !== "" ? (
                        <div style={{display:'flex', flexDirection:'column', justifyContent:'start', alignItems:'center', height:'auto', width:'100%'}}>
                            {(() => {
                                const usesCorCannon =
                                    taskIdData?.cor_use_center === true ||
                                    taskIdData?.cor_use_hot_spot === true;

                                return (
                                    <>
                            <div className='taskman-info-item'>
                                <div className='taskman-info-item-header'>Task ID</div>
                                <div className='taskman-info-item-content'>{taskIdData.full_task}</div>
                            </div>
                            <div className='taskman-info-item'>
                                <div className='taskman-info-item-header'>Project Title</div>
                                <div className='taskman-info-item-content'>{taskIdData.proj_title}</div>
                            </div>
                            <div className='taskman-info-item'>
                                <div className='taskman-info-item-header'>Task Type</div>
                                <div className='taskman-info-item-content'>{taskIdData.task_type}</div>
                            </div>
                            <div className='taskman-info-item'>
                                <div className='taskman-info-item-header'>W.O. Purpose</div>
                                <div className='taskman-info-item-content'>{taskIdData.work_order_purpose}</div>
                            </div>
                            <div className='taskman-info-item'>
                                <div className='taskman-info-item-header'>Task Title</div>
                                <div className='taskman-info-item-content'>{taskIdData.task_title}</div>
                            </div>
                            {usesCorCannon && (
                                <>
                                    <div className='taskman-info-item'>
                                         <div className='taskman-info-item-header'>use COR hot spot</div>
                                         <div className='taskman-info-item-content'>{taskIdData.cor_use_hot_spot ? 'True' : 'False'}</div>
                                    </div>
                                    <div className='taskman-info-item'>
                                         <div className='taskman-info-item-header'>use COR center</div>
                                         <div className='taskman-info-item-content'>{taskIdData.cor_use_center ? 'True' : 'False'}</div>
                                    </div>
                                </>
                            )}
                            {(taskIdData.is_sound && typeof taskIdData.is_sound === "boolean") ? (
                                <div className='taskman-info-item'>
                                    <div className='taskman-info-item-header'>Sound Test</div>
                                    <div className='taskman-info-item-content'>{taskIdData.is_sound ? "Yes" : "No"}</div>
                                </div>
                                
                            ) : (
                                <div className='taskman-info-item'>
                                    <div className='taskman-info-item-header'>Sound Test</div>
                                    <div className='taskman-info-item-content'>No</div>
                                </div>
                            )}
                            {(taskIdData.quantity && typeof taskIdData.quantity === "number" && taskIdData.quantity > 0 && taskIdData.task_type === "Robot") && (
                                <div className='taskman-info-item'>
                                    <div className='taskman-info-item-header'>Series Count</div>
                                    <div className='taskman-info-item-content'>{taskIdData.quantity}</div>
                                </div>
                            )}
                            {(taskIdData.robot_face_location && typeof taskIdData.robot_face_location === "string") && (
                                <div className='taskman-info-item'>
                                    <div className='taskman-info-item-header'>Face Location</div>
                                    <div className='taskman-info-item-content'>{taskIdData.robot_face_location}</div>
                                </div>
                            )}
                                    </>
                                );
                            })()}
                            {(robotTestData) && (
                                <div className='taskman-info-robo-data-header'>
                                    <div className='taskman-info-robo-data-title' style={{width:'200px', minHeight:'40px', fontWeight:'bold'}}>Robot Test Parameters</div>
                                    {Object.entries(robotTestData).map(([key, value]) => (
                                        <>
                                            {validRobotTestData(key) && (
                                                <div className='taskman-info-robo-data-item'>
                                                    <div className='taskman-info-robo-data-title'>{getAdjustedRobotTestDataKey(key)}</div>
                                                    <div className='taskman-info-robo-data-content'>{getAdjustedRobotTestDataValue(key, value)}</div>
                                                </div>
                                            )}
                                        </>
                                    ))}
                                </div>
                            )}
                        </div>
                    ) : (
                        <div style={{width:'100%', height:'40px', fontStyle:'italic', textAlign:'center'}}>
                            No task selected.
                        </div>
                    )}
                    
                    <div className='taskman-header-inner'>Components</div>
                    <div style={{width:'100%', minHeight: taskComponentData && taskComponentData.length > 0 ? 'calc( ' + taskComponentData.length * 50 + "px)" : '50px', overflow:'hidden'}}>
                        {Array.isArray(taskComponentData) && taskComponentData.length > 0 ? (
                            <FlipMove duration={200} easing='ease-in-out' staggerDurationBy={20} enterAnimation='fade' leaveAnimation='fade'>
                            {taskComponentData.map((item, index) =>(
                                <Collapsible trigger={(
                                    <div className='taskman-collapsible-header'>
                                        {getComponentType(item) === "Club" && (
                                            <div className='taskman-collapsible-header-left' style={{ marginLeft: '10px', fontSize: '20px' }}>
                                                {intToUppercaseLetter(item.index)}
                                            </div>
                                        )}
                                        <div className='taskman-collapsible-header-left' style={{marginLeft:'20px'}}>
                                            {getValidComponentHeader(item)}
                                        </div>
                                        {/* <div className='taskman-collapsible-header-left' style={{marginLeft:'10px', fontWeight:'normal'}}>
                                            {"(" + getValidBaseSN(item) + ")"}
                                        </div> */}
                                        <div className='taskman-collapsible-header-right'>
                                            <div style={{display: 'flex', flexDirection:'row', justifyContent:'start'}}>
                                                <button style={{background:'transparent', border:'0'}} type="button" disabled={IsTopMostComponent(item)} onClick={e => handleMoveComponentUp(e, item)}>
                                                    <ArrowUp disabled={IsTopMostComponent(item)}/>
                                                </button>
                                                <button style={{background:'transparent', border:'0'}} type="button" disabled={IsBottomMostComponent(item)} onClick={e => handleMoveComponentDown(e, item)}>
                                                    <ArrowDown disabled={IsBottomMostComponent(item)}/>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                )} key={item.id}>
                                    <div style={{height:'auto', width:'100%', display:'flex', flexDirection:'column', justifyContent:'start'}}>
                                        <div style={{height:'auto', width:'100%', display:'flex', flexDirection:'row', justifyContent:'start'}}>
                                            <div className='taskman-collapsible-inner' style={{width:'50%'}}>
                                                {getComponentType(item) === "Club" && (
                                                    <>
                                                        <div className='taskman-collapsible-inner-item'>
                                                            <div className='taskman-collapsible-inner-item-header'>Brand</div>
                                                            <div className='taskman-collapsible-inner-item-content'>{safeDisplayValue(item.brand)}</div>
                                                        </div>
                                                        <div className='taskman-collapsible-inner-item'>
                                                            <div className='taskman-collapsible-inner-item-header'>Product</div>
                                                            <div className='taskman-collapsible-inner-item-content'>{safeDisplayValue(item.product)}</div>
                                                        </div>
                                                        <div className='taskman-collapsible-inner-item'>
                                                            <div className='taskman-collapsible-inner-item-header'>Category</div>
                                                            <div className='taskman-collapsible-inner-item-content'>{safeDisplayValue(item.category)}</div>
                                                        </div>
                                                        <div className='taskman-collapsible-inner-item'>
                                                            <div className='taskman-collapsible-inner-item-header'>Stated Loft</div>
                                                            <div className='taskman-collapsible-inner-item-content'>{getLoft(item)}</div>
                                                        </div>
                                                        <div className='taskman-collapsible-inner-item'>
                                                            <div className='taskman-collapsible-inner-item-header'>Base Component SN</div>
                                                            <div className='taskman-collapsible-inner-item-content'>{getValidBaseSN(item)}</div>
                                                        </div>
                                                        <div className='taskman-collapsible-inner-item'>
                                                            <div className='taskman-collapsible-inner-item-header'>Head SN</div>
                                                            <div className='taskman-collapsible-inner-item-content'>{getValidHeadSN(item)}</div>
                                                        </div>
                                                        <div className='taskman-collapsible-inner-item'>
                                                            <div className='taskman-collapsible-inner-item-header'>Shaft SN</div>
                                                            <div className='taskman-collapsible-inner-item-content'>{getValidShaftSN(item)}</div>
                                                        </div>
                                                    </>
                                                )}
                                                {getComponentType(item) === "Ball" && (
                                                    <>
                                                        {renderEditableComponentField(item, 'Group Number', 'group_num', 'string')}
                                                        {renderRemoveComponentButton(item)}
                                                    </>
                                                )}
                                            </div>
                                            {getComponentType(item) !== "Ball" && (

                                            <div className='taskman-collapsible-inner' style={{width:'calc(50% - 2px)', marginLeft:'2px'}}>
                                                {renderEditableComponentField(item, 'Meas. Loft', 'loft_meas', 'number', 'N/A')}
                                                {renderEditableComponentField(item, 'Meas. Lie', 'lie_meas', 'number', 'N/A')}
                                                {renderEditableComponentField(item, 'Mass', 'mass', 'number', 'N/A')}
                                                {renderEditableComponentField(item, 'Club Length', 'club_length', 'number', 'N/A')}
                                                {renderEditableComponentField(item, 'Club SW', 'club_sw', 'string', 'N/A')}
                                                {renderEditableComponentField(item, 'Club Freq', 'club_freq', 'number', 'N/A')}
                                            </div>
                                            )}
                                        </div>
                                        {testType === 'FACEMAP' && (
                                            <div style={{height:'auto', width:'100%', display:'flex', flexDirection:'column', justifyContent:'start', marginTop:'2px'}}>
                                                <div className='taskman-collapsible-inner' style={{width:'100%'}}>
                                                        {Array.isArray(testData) && testData.length > 0 ? (
                                                    <>
                                                    {testData.map((testOption, idx) =>(
                                                        <div key={idx} className='taskman-collapsible-inner-item'>
                                                            <div className='taskman-collapsible-inner-item-header'>{testOption["Name"]}</div>
                                                            <div className='taskman-collapsible-inner-item-content'>{"y: " + testOption["y"] + ", z: "+ testOption["z"]}</div>
                                                        </div>
                                                    ))}
                                                    </>
                                                ) : (
                                                    <div className='taskman-collapsible-inner-item'>
                                                            <div className='taskman-collapsible-inner-item-content'>No valid face map data available</div>
                                                        </div>
                                                )}
                                            </div>
                                        </div>
                                        )}
                                    </div>
                                </Collapsible>
                            ))}
                            </FlipMove>
                        ) : 
                        <div className='taskman-collapsible-header-empty'>
                            {taskIdDataLoadingText}
                        </div>
                        }
                        {taskIdData !== null && taskIdData !== undefined && taskIdData !== "" && taskIdData.task_type === "Robot" && (
                            <div style={{width:'100%', display:'flex', justifyContent:'start', marginTop:'8px'}}>
                                <button
                                    type='button'
                                    onClick={handleAddComponent}
                                    className='button'
                                    style={{
                                        display:'flex',
                                        alignItems:'center',
                                        justifyContent:'start',
                                        width:'auto',
                                        height:'40px',
                                        padding:'0',
                                    }}
                                    aria-label='Add component'
                                >
                                    <div style={{width:'40px', height:'100%'}}>
                                        <AddIcon />
                                    </div>
                                    <div style={{width:'auto', paddingRight:'10px'}}>Add New Group Number</div>
                                </button>
                            </div>
                        )}
                    </div>
                    {taskIdData?.task_type !== "Robot" && (
                        <div style={{width:'100%'}}>
                            <div className='taskman-header-inner'>Golfers</div>
                            <div style={{width:'calc(100% - 6px)'}} ref={golfersRef}>
                                <BuildableGolferList ModalRef={modalRef} ScrollRef={scrollRef} ListUpdated={handleGolferListChange} GolferList={loadedGolfers}/>
                            </div>
                        </div>
                    )}
                    {taskIdData !== null && taskIdData !== undefined && taskIdData !== "" && taskIdData.task_type === "Robot" && (
                        <div style={{width:'100%'}}>
                            <div className='taskman-header-inner'>Tests</div>
                            <div style={{width:'calc(100% - 6px)'}} ref={testsRef}>
                                <div style={{width:'100%', height:'50px'}}>
                                    <Select
                                        options={ballTestOptions}
                                        value={selectedTestOption}
                                        onChange={handleTestSelectChange}
                                        placeholder="Use pulldown arrow to add tests"
                                        isSearchable={false}
                                        isClearable={false}
                                        classNamePrefix='search-input'
                                        menuPortalTarget={document.body}
                                        menuPosition='fixed'
                                        styles={{
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999,
                                            }),
                                            option: (base, { isFocused, isSelected }) => ({
                                                ...base,
                                                backgroundColor: isFocused || isSelected ? getComputedStyle(document.documentElement).getPropertyValue('--selected-highlight') : getComputedStyle(document.documentElement).getPropertyValue('--input-background'),
                                                color: isFocused || isSelected ? getComputedStyle(document.documentElement).getPropertyValue('--input-background') : getComputedStyle(document.documentElement).getPropertyValue('--input-background-invert'),
                                            }),
                                        }}
                                    />
                                </div>
                                <div className='golfer-list'>
                                    <DndContext
                                        collisionDetection={closestCenter}
                                        onDragStart={handleTestDragStart}
                                        onDragMove={handleTestDragMove}
                                        onDragEnd={handleTestDragEnd}
                                    >
                                        <SortableContext
                                            items={selectedTests.map((item) => item.value)}
                                            strategy={rectSwappingStrategy}
                                        >
                                            {selectedTests.map((test, index) => (
                                                <SortableTest
                                                    key={test.value}
                                                    id={test.value}
                                                    index={index}
                                                    test={test}
                                                    onRemove={handleRemoveTest}
                                                    disabled={selectedTests.length === 1}
                                                />
                                            ))}
                                        </SortableContext>
                                        <DragOverlay adjustScale={false} style={getTestOverlayStyle(modalRef, testPointerCoordinates)}>
                                            {activeTestId ? (
                                                <SortableTest
                                                    id={activeTestId}
                                                    test={selectedTests.find((item) => item.value === activeTestId)}
                                                    onRemove={() => {}}
                                                    disabled={selectedTests.length === 1}
                                                />
                                            ) : null}
                                        </DragOverlay>
                                    </DndContext>
                                    {selectedTests.length === 0 && (
                                        <div style={{width:'100%', height:'50px', alignItems:'center', justifyContent:'center', display:'flex'}}>No tests selected.</div>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                    <div style={{width:'100%'}}>
                        <div className='taskman-header-inner'>Data Collector</div>
                        <div ref={dcRef}>
                            
                            <UserList dbInitialized={true} UserChanged={handleDCChange} LoadedUser={loadedDC} HasEditPermission={false} />
                        </div>
                    </div>
                    <div style={{width:'100%'}}>
                        <div className='taskman-header-inner'>Venue</div>
                        <div ref={venueRef}>
                            <VenueList dbInitialized={true} VenueChanged={handleVenueChange} LoadedVenue={loadedVenue} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-footer" style={{flexShrink:'0'}}>
                <button className="button" disabled={!valid} style={{width:'100px'}} onClick={() => handleTaskmanComplete()}>Start</button>
            </div>
            <Modal
                open={loadingModal}>
                <div className='taskman-modal-container'>
                    <div style={{marginBottom:'5px',marginTop:'5px'}}>
                        {loadingModalText}
                    </div>
                    <div className='loader'></div>
                    <div style={{marginTop:'10px'}}/>
                </div>
            </Modal>
            <Modal
                open={errorModal}>
                <div className='taskman-modal-container'>
                    <div style={{marginBottom:'5px',marginTop:'5px'}}>
                        {errorModalText}
                    </div>
                    <button className='button' onClick={() => setErrorModalState(false)}>Okay</button>
                </div>
            </Modal>
            <Modal
                open={conflictTaskModal}>
                <div>
                    <div className='taskman-modal-container' style={{maxWidth:'400px', maxHeight:'200px', justifyContent:'start'}}>
                        <button className='modal-close-button' style={{width:'40px', height:'40px'}} onClick={() => handleLoadConflictSessionCancel()}><Cross2Icon width='30px' height='30px'/></button>
                        <div style={{margin:'10px', height:'calc(100% - 120px)', marginTop:'60px', textAlign:'center', alignContent:'center'}}>
                            {"Task " + selectedTaskId + " already has a session. Do you want to load it?"}
                        </div>
                        <div style={{display:'flex', flexDirection:'row', justifyContent:'center', gap:'10px', margin:'10px'}}>
                            <button className='button' style={{width:'100px', height:'40px'}} onClick={() => handleLoadConflictSession()}>Yes</button>
                            <button className='button' style={{width:'100px', height:'40px'}} onClick={() => handleLoadConflictSessionCancel()}>No</button>
                        </div>
                    </div>
                </div>
            </Modal>
            <Modal
                open={closeModal}>
                <div className='taskman-modal-close-container'>
                    <button className='modal-close-button' onClick={() => setCloseModalState(false)}><Cross2Icon width='30px' height='30px'/></button>
                    <div style={{marginBottom:'5px',marginTop:'60px', marginLeft:'20px', marginRight:'20px'}}>
                        You have information entered for a task that will be lost.
                    </div>
                    <div style={{marginBottom:'5px',marginTop:'5px', marginLeft:'20px', marginRight:'20px'}}>
                        Are you sure?
                    </div>
                    <button className='button' style={{marginTop:'auto', marginBottom:'10px'}} onClick={() => handleConfirmClose()}>Yes</button>
                </div>
            </Modal>
            <Modal
                open={newTestModalOpen}>
                <div className='taskman-modal-container' style={{maxWidth:'400px', minHeight:'220px', justifyContent:'start'}}>
                    <button className='modal-close-button' onClick={() => handleNewTestModalCancel()}><Cross2Icon width='30px' height='30px'/></button>
                    <div style={{marginTop:'60px', marginBottom:'10px', fontWeight:'bold'}}>
                        Add New Test
                    </div>
                    <input
                        className='input'
                        type='text'
                        value={newTestName}
                        onChange={(e) => setNewTestName(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' && newTestName.trim() !== "") {
                                e.preventDefault();
                                handleNewTestModalOk();
                            }
                        }}
                        placeholder='Enter test name'
                        style={{width:'calc(100% - 40px)', marginLeft:'20px', marginRight:'20px'}}
                    />
                    <div style={{display:'flex', flexDirection:'row', justifyContent:'center', gap:'10px', marginTop:'auto', marginBottom:'20px'}}>
                        <button className='button' style={{width:'100px'}} onClick={() => handleNewTestModalOk()} disabled={newTestName.trim() === ""}>OK</button>
                        <button className='button' style={{width:'100px'}} onClick={() => handleNewTestModalCancel()}>Cancel</button>
                    </div>
                </div>
            </Modal>
        </div>
    )
}

function getTestOverlayStyle(modalRef, pointerCoordinates) {
    if (modalRef?.current) {
        const modal = modalRef.current.getBoundingClientRect();

        return {
            position: 'absolute',
            top: pointerCoordinates.y - modal.y,
            left: modal.x + 40,
            transform: 'translate(0px, -50%)',
        };
    }

    return {
        position: 'fixed',
        top: pointerCoordinates.y,
        left: pointerCoordinates.x,
        transform: 'translate(-50%, -50%)',
    };
}

function SortableTest({ id, index = null, test, onRemove, disabled }) {
    const { attributes, listeners, setNodeRef, transform, transition } =
        useSortable({ id, disabled });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
    };

    if (!test) {
        return null;
    }

    return (
        <div ref={setNodeRef} style={style} {...attributes} className="golfer-list-item">
            <button
                className="golfer-list-item-move-button"
                disabled={disabled}
                {...listeners}
                style={{
                    cursor: disabled ? 'default' : 'grab',
                }}
            >
                <HandleIcon width='30px' height='30px' className={disabled ? 'icon-both-disabled' : 'icon-both'}/>
            </button>
            <div className="golfer-list-item-label" style={{ flexGrow: 1 }}>
                {((index != null && index !== undefined && !Number.isNaN(index)) ? (index + 1) + ":\u00A0\u00A0\u00A0" : "") + test.label}
            </div>
            <button
                className="golfer-list-item-remove-button"
                onClick={() => onRemove(test.value)}
                style={{
                    border: 'none',
                    background: 'transparent',
                    cursor: 'pointer',
                }}
            >
                <Cross2Icon width="30px" height="30px" />
            </button>
        </div>
    );
}

export default TaskmanSetup;
